import { useContext } from 'react'
import { TimelineContext } from '@/contexts/timeline'
import { CurationContext } from '@/contexts/curation'

export function usePostCardContext() {
  const timelineContext = useContext(TimelineContext)
  const curationContext = useContext(CurationContext)
  const isInCuration = !!curationContext && !timelineContext

  return {
    timelineContext,
    curationContext,
    isInCuration
  }
}
